var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"outil",attrs:{"id":"UserFlowBtn"}},[_c('icon-base',{attrs:{"viewBox":"0 0 19 24","width":"19","height":"24"}},[_c('IconCAPas')],1),_vm._v(" "+_vm._s(_vm.$t('centre_aide_btn_uf'))+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }